import React, { useState } from "react"
import { Input, Container, Form, FormGroup, Alert } from "reactstrap"
import validateInput from "../../view/shared/validations/codeVerify"
import { Trans, useLingui } from "@lingui/react"
import "react-phone-number-input/style.css"
import "react-phone-input-2/lib/style.css"
import ar from "react-phone-input-2/lang/ar.json"
import PhoneInput from "react-phone-input-2"
import { NavLink } from "react-router-dom"
import PropTypes from "prop-types"

const VerifyCode = (props) => {
  const { i18n } = useLingui()
  const [phone_number, setPhoneNumber] = useState("")
  const [token, setToken] = useState("")
  const [errors, setErrors] = useState({})
  const [_country] = React.useState(localStorage.getItem("_country") || "GH")

  const onChange = (e) => {
    if (e.target.name === "phone_number") {
      setPhoneNumber(e.target.value)
    } else if (e.target.name === "token") {
      setToken(e.target.value)
    }
  }

  const isValid = () => {
    const { errors, isValid } = validateInput({ phone_number, token })
    if (!isValid) {
      setErrors(errors)
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      props.history.push({
        pathname: `/pinReset`,
        pincode: token,
        phone: phoneValidate("+" + phone_number),
      })
    }
  }

  const phoneValidate = (phone) => {
    if (phone === "+") {
      return ""
    } else {
      return phone
    }
  }

  const inputStyle = {
    flex: "10",
    fontFamily: "Fira Sans",
    height: "50px",
    width: "100%",
    fontSize: "20px",
  }

  const formStyle = {
    flex: "10",
    padding: "5px",
    fontFamily: "Fira Sans",
    fontSize: "20px",
    height: "50px",
    width: "100%",
  }

  return (
    <div>
      <Container>
        <Alert color="secondary" style={loadingStyle}>
          <Trans id="placeholder_copy.token_sent" />{" "}
          <i>
            <NavLink to="/PhoneVerify">
              <Trans id="placeholder_copy.resend_token" />
            </NavLink>
          </i>
        </Alert>
        <Form onSubmit={onSubmit}>
          <FormGroup
            style={{
              direction: "ltr",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span style={{ color: "red" }}>{errors.phone_number}</span>
            <PhoneInput
              country={_country.toLocaleLowerCase()}
              enableSearch
              disableSearchIcon
              placeholder={i18n._("Phone Number")}
              inputStyle={inputStyle}
              style={loadingStyle}
              value={phone_number}
              onChange={(value) => setPhoneNumber(value)}
              limitMaxLength={true}
              localization={i18n.locale === "ar" ? ar : false}
            />
          </FormGroup>
          <FormGroup>
            <span style={{ color: "red" }}>{errors.pin}</span>
            <input
              type="number"
              name="token"
              placeholder={i18n._("Verification code")}
              style={formStyle}
              value={token}
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="submit"
              value={i18n._("Submit")}
              name="submit"
              className="btn btn-primary"
              size="lg"
            />
          </FormGroup>
        </Form>
      </Container>
    </div>
  )
}

VerifyCode.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "18px",
}
export default VerifyCode
